import axios from 'axios';
import { BASENAME } from './constants';

const axiosInstance = axios.create({
	baseURL: BASENAME + '/api',
	timeout: 120000
});

const api = {
	getAppVersion: () =>
		axiosInstance
			.get(`/appVersion`)
			.then(response => response.data)
			.catch(e => {
				console.error(e);
				return '';
			}),
	getUserInfo: () =>
		axiosInstance
			.get(`/getUserInfo`)
			.then(response => response.data)
			.catch(e => {
				console.error(e);
				return '';
			})
};

export default api;
